var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}.c{fill:url(#b);}.d{fill:url(#c);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    transform: "translate(658 399)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a93aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff81ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbef9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff1ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-658 -399)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(658 399)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.956,34.549H4.307a1.436,1.436,0,0,0,0,2.871H14.956a1.436,1.436,0,0,0,0-2.871Zm-.5-7.178a1.435,1.435,0,0,0-1.436-1.436H1.436a1.436,1.436,0,0,0,0,2.871h11.58A1.435,1.435,0,0,0,14.451,27.371Zm.5-10.049H4.307a1.436,1.436,0,0,0,0,2.871H14.956a1.436,1.436,0,0,0,0-2.871Zm19.593-5.669c-.192-.017-.384-.505-.577-1.076l.577-1.867h1.436a1.436,1.436,0,0,0,0-2.871H30.242a1.436,1.436,0,0,0,0,2.871h1.436l.621,1.735c-.208.627-.415,1.191-.621,1.209a15.887,15.887,0,1,0,2.871,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M41.727,25.936H34.549V18.758a1.435,1.435,0,0,0-1.436-1.436A10.049,10.049,0,1,0,43.162,27.371,1.435,1.435,0,0,0,41.727,25.936ZM34.549,11.653V8.709H31.678v2.944c.474-.043.951-.073,1.436-.073S34.075,11.61,34.549,11.653Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.8b614641d3ffd29f5d85cfdf19354d82.svg";
export { ForwardRef as ReactComponent };